import { Provider } from 'react-redux';
import { store } from '@app/store/store';
import { LocaleContextProvider, useLocaleManager } from '@app/translations';
export const AppProviders = ({ children }) => {
    const { locale, changeLocale, loaded } = useLocaleManager();
    return (<Provider store={store}>
            <LocaleContextProvider value={{ locale, changeLocale, loaded }}>{children}</LocaleContextProvider>
        </Provider>);
};
